import { useState, useEffect, useCallback } from 'react'

export default function useWindowSize(hOffset: number, wOffset: number) {
  const getSize = useCallback(() => {
    return {
      width: window.innerWidth - wOffset,
      height: window.innerHeight - hOffset,
    }
  }, [hOffset, wOffset])

  const [size, setSize] = useState(getSize())

  useEffect(() => {
    const handleResize = () => {
      setSize(getSize)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [getSize])

  return size
}
